import React from 'react';

var MobileFooterWr = function (_a) {
    var isShowBalanceWin = _a.isShowBalanceWin, children = _a.children;
    return (React.createElement("div", { className: "pgc-m-footer ".concat(isShowBalanceWin ? 'balance-win' : '') }, children));
};

export { MobileFooterWr };
